import styled from '@emotion/styled';

export const GridLayoutContainer = styled.div<{ itemsCountPerRow: number }>`
  display: grid;
  grid-gap: 24px 16px;
  grid-auto-flow: row;
  grid-template-columns: repeat(${props => props.itemsCountPerRow}, minmax(155px, 220px));
  justify-content: center;
`;
